import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import fetchMiddleware from './FetchMiddleware';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native

import rootReducer from './reducers/RootReducer';

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['group', 'snackbar']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  applyMiddleware(fetchMiddleware)
);

export const persistor = persistStore(store);
